import './mix&twist1/style';
import FormStructure from './mix&twist1/form_structure';

export default FormStructure;